import React, { useEffect, useState } from "react";
import { Card, Input, Button, message, Spin } from "antd";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import SummaryApi from "../../../common/index";
import { UserOutlined } from "@ant-design/icons";
import "../../../Styles/AdminStylings/UserDetails.css";

const { TextArea } = Input;

const UserDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [loading, setLoading] = useState(false);

  const fetchUser = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${SummaryApi.getUserById.url(id)}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
        },
      });
      if (response.data.success) setUser(response.data.user);
      else message.error("Failed to load user");
    } catch {
      message.error("Error fetching user");
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async () => {
    try {
      await axios.put(`${SummaryApi.updateUser.url(id)}`, user, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
          "Content-Type": "application/json",
        },
      });
      message.success("User updated successfully");
      setEditMode(false);
      fetchUser();
    } catch {
      message.error("Failed to update user");
    }
  };

  useEffect(() => {
    fetchUser();
  }, [id]);

  if (loading || !user)
    return (
      <div className="loading-container">
        <Spin size="large" />
      </div>
    );

  return (
    <div className="user-details-container">
      <Card className="user-card">
        <div className="user-profile-icon">
          <UserOutlined className="profile-icon" />
        </div>

        <h2 className="user-name">{user.name}</h2>

        <div className="user-info-section">
          <div className="info-item">
            <label>Email</label>
            {editMode ? (
              <Input
                value={user.email}
                onChange={(e) => setUser({ ...user, email: e.target.value })}
              />
            ) : (
              <p>{user.email}</p>
            )}
          </div>

          <div className="info-item">
            <label>Mobile</label>
            {editMode ? (
              <Input
                value={user.mobile}
                onChange={(e) => setUser({ ...user, mobile: e.target.value })}
              />
            ) : (
              <p>{user.mobile}</p>
            )}
          </div>

          <div className="info-item">
            <label>Address</label>
            {editMode ? (
              <TextArea
                rows={2}
                value={user.address}
                onChange={(e) => setUser({ ...user, address: e.target.value })}
              />
            ) : (
              <p>{user.address || "N/A"}</p>
            )}
          </div>

          <div className="info-item">
            <label>Role</label>
            {editMode ? (
              <Input
                value={user.role}
                onChange={(e) => setUser({ ...user, role: e.target.value })}
              />
            ) : (
              <p>{user.role}</p>
            )}
          </div>
        </div>

        <div className="button-group">
          {editMode ? (
            <>
              <Button type="primary" onClick={handleSave}>
                Save
              </Button>
              <Button onClick={() => setEditMode(false)}>Cancel</Button>
            </>
          ) : (
            <>
              <Button onClick={() => navigate(-1)}>Back</Button>
              <Button type="primary" onClick={() => setEditMode(true)}>
                Edit
              </Button>
            </>
          )}
        </div>
      </Card>
    </div>
  );
};

export default UserDetails;
